module.exports = __webpack_public_path__ + "img/close.a7e59b86.png";